export { default } from 'modules/specialist';
